import HTTPClient from '../common/http-client'

export const mediaService = {
  getTopMedia
}

async function getTopMedia() {
  const mediaRes = await HTTPClient.getInstance().httpMedia.get()
  return mediaRes.data.data
}



// WEBPACK FOOTER //
// ./src/_services/media.service.js